import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SmbIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "6.73684",
                fill: "#6C6CFF"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_506_4029)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M31.5694 22.9025L29.7935 21.5225V17.09H26.4215V18.98L23.4241 16.73L15.2789 22.9025C15.1091 23.0574 15.0068 23.2729 14.9941 23.5025V32.855C14.9941 33.0539 15.0731 33.2447 15.2136 33.3853C15.3541 33.5259 15.5447 33.605 15.7435 33.605H31.1198C31.3186 33.605 31.5091 33.5259 31.6497 33.3853C31.7902 33.2447 31.8691 33.0539 31.8691 32.855V23.465C31.8432 23.2465 31.7362 23.0457 31.5694 22.9025Z",
                    stroke: "white",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_506_4029",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(14.4316 16.1675)"
                    })
                })
            })
        ]
    });
